import styled from 'styled-components';

export const UntaggedClusterName = styled.div`
  padding: 0 20px 0 15px;
`;
